const HOST = process.env.REACT_APP_HOST + "/api/v1";

export { HOST };